import { render } from "./withMenuReadModel.vue?vue&type=template&id=2529cf28"
import script from "./withMenuReadModel.vue?vue&type=script&lang=js"
export * from "./withMenuReadModel.vue?vue&type=script&lang=js"

import "./withMenuReadModel.vue?vue&type=style&index=0&id=2529cf28&lang=scss"
import "./withMenuReadModel.vue?vue&type=style&index=1&id=2529cf28&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__